/**
 * Represents information about a "Partner Project", which get special information displayed on the details page.
 * This information is hardcoded into this file for each project.
 * TODO this can be supplied by a database.
 */
type PartnerProject = {
  // Unique string identifier for this partner project.
  // Shows up in the token view, and in the details section of the detail page.
  name: string
  // Base URL for the entire project, when you click this link, takes you to the project URL.
  projectUrl: string
  // Relative path for the logo
  logoImagePath: string
}

export const PartnerProjects: { [key: string]: PartnerProject } = {
  hedsDAO: {
    name: 'hedsDAO',
    projectUrl: 'https://heds.io',
    logoImagePath: '/static/images/heds.png'
  },
  catalog: {
    name: 'Catalog',
    projectUrl: 'https://catalog.works',
    // TODO
    logoImagePath: '/static/images/heds.png'
  }
}
